import { render, staticRenderFns } from "./CreaCuenta.vue?vue&type=template&id=3901f32a&scoped=true"
import script from "./CreaCuenta.vue?vue&type=script&lang=js"
export * from "./CreaCuenta.vue?vue&type=script&lang=js"
import style0 from "./CreaCuenta.vue?vue&type=style&index=0&id=3901f32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901f32a",
  null
  
)

export default component.exports